import { RentalPortalApplicantProfile } from '../../RentalPortalApplicantProfile'

import * as styles from './RentalPortalApplicantMultipleViewTypeListActiveItemPreview.module.css'

function RentalPortalApplicantMultipleViewTypeListActiveItemPreview({
  activeItem,
  className = styles.RentalPortalApplicantMultipleViewTypeListActiveItemPreview,
  onClose,
}) {
  return (
    <RentalPortalApplicantProfile
      isPreview
      applicantId={activeItem}
      layoutProps={{ className }}
      onClosePreview={onClose}
    />
  )
}

export default RentalPortalApplicantMultipleViewTypeListActiveItemPreview
